import { useEffect, useState } from 'react'
import { getChartTheme, type ChartMode, type ChartTheme } from './palette'

function currentMode(): ChartMode {
  if (typeof document === 'undefined') return 'light'
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light'
}

/**
 * Тема графиков следует за классом `dark` на `<html>` (так тему переключает `ThemeToggle`).
 * Переключение темы пересобирает опции графика из тех же данных — отдельной «тёмной палитры на лету» нет:
 * у тёмной темы свои ступени, проверенные валидатором.
 */
export function useChartTheme(): ChartTheme {
  const [mode, setMode] = useState<ChartMode>(currentMode)

  useEffect(() => {
    if (typeof MutationObserver === 'undefined') return
    const observer = new MutationObserver(() => setMode(currentMode()))
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
    setMode(currentMode())
    return () => observer.disconnect()
  }, [])

  return getChartTheme(mode)
}

/** Нужна ли текстура (decal): принудительные цвета ОС или печать. По умолчанию выключена. */
export function prefersTexture(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  try {
    return window.matchMedia('(forced-colors: active)').matches
  } catch {
    return false
  }
}
